<template>
    <div id="app">
        <keep-alive>
           <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
'use strict'

import '@src/style/reset.styl'
import '@src/style/common.styl'
import '@src/style/animation.styl'

export default {
    name: 'app'
}
</script>

<style lang="stylus">
#app {
    margin 0 auto
    max-width 1080px
}
#app, .page {
    position relative
    // z-index 5
    width 100%
    height 100%
}
</style>



// WEBPACK FOOTER //
// src/App.vue